import React from "react";
import Alert from '@mui/material/Alert';
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import useClasses from "../useClasses";

const styles = (theme) => ({
  root: {
    width: "fit-content",
    marginTop: 16,
  },
  alert: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  text: {
    color: "rgb(13, 60, 97)",
    backgroundColor: "rgb(232, 244, 253)",
    padding: theme.spacing(0, 1, 2, 6),
  },
});

function NoAccessMessage() {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Alert severity="info" className={classes.alert}>
        {t("surveys.noAccessRights")}
      </Alert>
      <div className={classes.text}>
        <Typography variant="body2">• {t("surveys.exampleClient")}</Typography>
        <Typography variant="body2">• {t("surveys.sharingClient")}</Typography>
      </div>
    </div>
  );
}

export default NoAccessMessage;
